module.exports = __webpack_public_path__ + "b806852652d321d084b53eac3908851e.png";